module.exports = __webpack_public_path__ + "static/img/researcherPageArea02.a7598ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/researcherPageArea02.jpg
// module id = FCXh
// module chunks = 3